document.addEventListener('DOMContentLoaded', function () {
  let toggles = document.querySelectorAll('.password-toggle');

  toggles.forEach(function (btn) {
    let input = document.querySelector(btn.dataset.target);

    if (!input) return;

    let openSvg = btn.querySelector('.eye-open');
    let closeSvg = btn.querySelector('.eye-closed');

    btn.addEventListener('click', function () {
      if (input.type === 'password') {
        input.type = 'text';

        if (openSvg) openSvg.style.display = 'none';
        if (closeSvg) closeSvg.style.display = 'block';
      } else {
        input.type = 'password';

        if (openSvg) openSvg.style.display = 'block';
        if (closeSvg) closeSvg.style.display = 'none';
      }
    });
  });
});
